import React, { useState } from "react";
import axios from "axios";
import { CheckCircle2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GIORNI = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
const FASCE = ["Mattina", "Pomeriggio", "Sera"];
const EMPTY = { nome: "", cognome: "", email: "", telefono: "", giorno: "", fascia: "", dettagli: "" };
const FIELDS = [
  ["nome", "Nome", "text"],
  ["cognome", "Cognome", "text"],
  ["email", "Email", "email"],
  ["telefono", "Telefono", "tel"],
];

export const ConsulenzaForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const missing = ["nome", "cognome", "email", "telefono", "giorno", "fascia"].some((k) => !form[k].trim());
    if (missing) return setError("Compila tutti i campi obbligatori.");
    if (!/^\S+@\S+\.\S+$/.test(form.email)) return setError("Inserisci un indirizzo email valido.");
    setSending(true);
    try {
      await axios.post(`${API}/consulenze`, form);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Invio non riuscito, riprova.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="cons-success" data-testid="cons-success">
        <CheckCircle2 size={40} strokeWidth={1.4} className="success-icon" />
        <h3 className="serif">Richiesta inviata, grazie!</h3>
        <p>Ti risponderò via email o telefono entro qualche ora.</p>
      </div>
    );
  }

  return (
    <form className="billing-grid cons-form" onSubmit={submit} data-testid="cons-form" noValidate>
      {FIELDS.map(([k, label, type]) => (
        <div className="billing-field" key={k}>
          <label>{label} <span className="req">*</span></label>
          <input type={type} value={form[k]} onChange={set(k)} data-testid={`cons-${k}-input`} />
        </div>
      ))}
      <div className="billing-field">
        <label>Giorno preferito <span className="req">*</span></label>
        <select className="prod-select" value={form.giorno} onChange={set("giorno")} data-testid="cons-giorno-select">
          <option value="">Seleziona un giorno</option>
          {GIORNI.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>
      </div>
      <div className="billing-field">
        <label>Fascia oraria <span className="req">*</span></label>
        <select className="prod-select" value={form.fascia} onChange={set("fascia")} data-testid="cons-fascia-select">
          <option value="">Seleziona una fascia</option>
          {FASCE.map((f) => <option key={f} value={f}>{f}</option>)}
        </select>
      </div>
      <div className="billing-field full">
        <label>Cosa vorresti approfondire?</label>
        <textarea
          className="prod-textarea"
          rows={5}
          value={form.dettagli}
          onChange={set("dettagli")}
          placeholder="Raccontami la tua struttura e su cosa vorresti lavorare insieme"
          data-testid="cons-dettagli-input"
        />
      </div>
      <div className="full">
        {error && <p className="commerce-inline-err" data-testid="cons-error">{error}</p>}
        <button type="submit" className="quiz-cta cons-cta" disabled={sending} data-testid="cons-submit-btn">
          {sending ? "Invio in corso..." : "Invia richiesta"} <Send size={16} strokeWidth={1.8} />
        </button>
      </div>
    </form>
  );
};
